// extracted by mini-css-extract-plugin
module.exports = {"label":"RadioLabel_label__17cm1"};